exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview[data-v-55279b64]{border:2px solid #fff;border-radius:.35rem}", ""]);

// exports
